// VERSÃO 2.0 - RESTAURADA E FUNCIONAL
import React, { useState, useEffect, useCallback } from 'react';
import { FiCpu, FiSave, FiRefreshCw, FiAlertCircle } from 'react-icons/fi';

const API_URL = import.meta.env.VITE_API_BASE_URL;

export default function ModulesPage() {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // A rota /api/links/data agora contém todas as informações que precisamos
      const response = await fetch(`${API_URL}/links/data`);
      if (!response.ok) {
        throw new Error(`Falha ao carregar dados: ${response.statusText}`);
      }
      const data = await response.json();

      const combinedData = (data.instances || []).map(instance => {
        const association = (data.associations || []).find(a => a.instanceName === instance.name);
        return {
          instanceName: instance.name,
          status: instance.connectionStatus === 'open' ? '🟢' : '🔴',
          responseMode: association?.responseMode || 'auto',
        };
      });
      setTableData(combinedData);

    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFieldChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    setTableData(updatedData);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Usamos a mesma rota de update dos links, que agora salva o responseMode
      const savePromises = tableData.map(row => {
        const payload = {
          instanceName: row.instanceName,
          responseMode: row.responseMode,
        };
        return fetch(`${API_URL}/links/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).then(res => {
          if (!res.ok) throw new Error(`Falha ao salvar módulo para ${row.instanceName}`);
        });
      });

      await Promise.all(savePromises);
      alert('Módulos de resposta salvos com sucesso!');

    } catch (err) {
      setError(err.message);
      alert(`Erro ao salvar: ${err.message}`);
    } finally {
      setIsLoading(false);
      fetchData();
    }
  };

  return (
    <div className="p-4 md:p-8">
      <header className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
        <h2 className="text-3xl font-bold text-gray-100 flex items-center gap-3"><FiCpu /> Gestão de Módulos</h2>
        <div className="flex gap-4">
          <button onClick={fetchData} className="bg-gray-600 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2" disabled={isLoading}>
            <FiRefreshCw /> Atualizar
          </button>
          <button onClick={handleSave} className="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2" disabled={isLoading}>
            <FiSave /> Salvar Alterações
          </button>
        </div>
      </header>
      <div className="bg-gray-800 border border-gray-700 rounded-xl p-1 md:p-4 overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-700">
          <thead className="bg-gray-800">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Status</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Instância</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Módulo de Resposta Padrão</th>
            </tr>
          </thead>
          <tbody className="bg-gray-900 divide-y divide-gray-700">
            {tableData.map((row, index) => (
              <tr key={row.instanceName}>
                <td className="px-4 py-4 whitespace-nowrap text-2xl">{row.status}</td>
                <td className="px-4 py-4 whitespace-nowrap font-medium text-white">{row.instanceName}</td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <select 
                    value={row.responseMode} 
                    onChange={(e) => handleFieldChange(index, 'responseMode', e.target.value)} 
                    className="bg-gray-700 text-white border-gray-600 rounded-md p-2 w-full max-w-xs"
                  >
                    <option value="auto">Automático (Texto/Áudio)</option>
                    <option value="text">Somente Texto</option>
                    <option value="audio">Somente Áudio</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
